export default __webpack_public_path__ + "static/media/carousel-customer-engagement.43446a7c.jpg";